<template>
  <div class="tan_needGz_portrait_botAdviseWrap" v-if="newAllData">
    
    <div class="bot_adviceWrap mt10">
      <img class="report_title_adviceIcon" src="../../../assets/report_title_advice_d@2x.png" alt="" v-if="newAllData.recommendLabel">
      <img class="report_title_adviceIcon" src="../../../assets/report_title_advice_d3.png" alt="" v-if="!newAllData.recommendLabel">
      <div class="bot_advice_tit"  v-html="$options.filters.reMate(newAllData.conclusionLabel)"></div>

      <div v-if="newAllData.recommendLabel">
        <div class="bot_advice_tit mt5">
          <div>参考建议</div>
        </div>
        <div class="referAdvWrap mt5" style="margin-left: 14px;">
          <div class="referAdvList" :key="index" v-for="(item,index) in newAllData.recommendLabel.recommendList">
            <img class="rep_Icon" :src="require('../../../assets/gzImg/icon_portrait_report_image_' + item.imageType + '.png')" />
            <div class="rep_tit">{{ item.recommend }}</div>
          </div>
        </div>
        <div class="bot_advice_tit mt10">
          <div>{{ newAllData.recommendLabel.recommend }}</div>
        </div>
      </div>
      

    </div>

    
  </div>
</template>

<script>
import portFn from '../../../utils/PortraitFunction.js';
import CustomRichText from '../../../utils/CustomRichText.js';

export default {
  components: {  },
  filters: {
    reMate(val){
      return CustomRichText.reMate(portFn.function_reg_str_to_arr(val))
    },
  },
  props: {
    haveChangeData: null,
  },
  watch: {
    haveChangeData(newVal,oldVal){
      this.newAllData = newVal
      console.log('进入了haveChange组件 且有变化了')
      console.log(this.newAllData)
    }
  },
  data() {
    return {
      newAllData: null,
    };
  },
  created() {},
  mounted() {
    this.newAllData = this.haveChangeData
    
  },
  methods: {
    
    
    


    
    
  },
};
</script>
<style lang="scss" scoped>

.tan_needGz_portrait_botAdviseWrap ::v-deep{

  .txjyWrap{
    width: 810px;
    height: auto;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid rgba(255,113,134,0.5);
    padding: 15px;
    box-sizing: border-box;
    display: block;
    .txjyTit{
      width: 356px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1F2635;
      margin-left: 14px;
      position: relative;
    }
    .txjyTit::after{
      width: 4px;
      height: 14px;
      background: #FF7186;
      border-radius: 2px;
      content: '';
      position: absolute;
      left: -14px;
      top: 5px;
    }
    .txjyTit_after_blue::after{
      background: #1890FF;
    }
    .txjyTit2{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9094A6;
      line-height: 20px;
      margin-top: 10px;
    }
    .refer_comTit{
      width: 780px;
      height: auto;
      background: #F3F4F7;
      border-radius: 4px;
      padding: 12px;
      box-sizing: border-box;

                  
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5E6779;
      position: relative;
    }
    .refer_comTit::after{
      content: '';
      width: 0px;
      height: 0px;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 12px solid #F3F4F7;
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }
    .refer_comLine_heng{
      width: 780px;
      height: 1px;
      opacity: 0.1;
      border: 1px solid #1F2635;
      margin-top: 15px;
    }
    .refer_comTit2{
      width: 780px;
      height: 52px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1F2635;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid rgba(255,113,134,0.5);
      padding: 0 15px;
      box-sizing: border-box;
      // display: flex;
      align-items: center;
      .reIcon{
        width: 15px;
        height: 15px;
        margin-right: 5px;
      }
    }
    .fer_txjyWrap{
      width: 780px;
      height: auto;
      background: #F3F4F7;
      border-radius: 4px;
      padding: 0 15px 15px 15px;
      .fer_txjy{
        width: 750px;
        height: 46px;
        border: 0;
        border-bottom: 1px solid #E8EAEE;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9094A6;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      .fer_txjyIcon{
        width: 14px;
        height: 14px;
      }
      
    }
    .lcTimeTip{
      display: flex;
      justify-content: center;
      align-items: center;
      .lcTimeKuang{
        width: 16px;
        height: 5px;
        background: #E0ECFC;
      }
      .lcTimeFont{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A5A9BC;
      }
    }
    .lcscSinWrap{
      width: 780px;
      height: auto;
      background: #F8F8FC;
      border-radius: 8px;
      padding: 12px 15px;
      box-sizing: border-box;
      .name{
        width: 96px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A5A9BC;
      }
      .boxBg{
        width: 750px;
        height: 8px;
        border-radius: 6px;
      }
      .boxBgData{
        width: 750px;
        height: 20px;
        display: flex;
        margin-top: 4px;
        .bNum{
          font-size: 10px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #A5A9BC;
          margin-left: 67.5px;
          position: relative;
        }
        .bNum:nth-of-type(1){
          margin-left: 0;
        }
      }
    }
    .zxSanWrap{
      display: flex;
      align-items: center;
      justify-content: center;
      .zxSanList{
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #A5A9BC;
        padding-left: 22px;
        box-sizing: border-box;
        position: relative;
      }
      .zxSanList::after{
        content: '';
        width: 6px;
        height: 6px;
        background: #FF7186;
        border-radius: 50%;
        position: absolute;
        left: 12px;
        top: 6px;
      }
      .zxSanList:nth-of-type(2):after{
        background: #FFB971;
      }
      .zxSanList:nth-of-type(3):after{
        background: #44D7B6;
      }
      .zxSanList:nth-of-type(4):after{
        background: #1890FF;
      }
    }
    .zxSanBotCont{
      width: 780px;
      height: auto;
      padding: 15px;
      box-sizing: border-box;
      background: #F3F4F7;
      border-radius: 4px;
      position: relative;
      .zxSanBotListWrap{
        display: flex;
        .zxSanBotList{
          width: 180px;
          height: 73px;
          background: #FFFFFF;
          border-radius: 4px;
          margin-left: 10px;
          .zxBoxBlock{
            width: 16px;
            height: 5px;
            background: #FFD4DA;
          }
          .zxBoxName{
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A5A9BC;
          }
        }
        .zxSanBotList:nth-of-type(1){
          margin-left: 0;
        }
      }
    }
    .zxSanBotCont::after{
      content: '';
      width: 0px;
      height: 0px;
      border-left: 9px solid transparent;
      border-right: 9px solid transparent;
      border-bottom: 12px solid #F3F4F7;
      position: absolute;
      top: -12px;
      left: 50%;
      transform: translateX(-50%);
    }

  }
  
  // 最下面的提醒建议
  .bot_adviceWrap{
    width: 810px;
    height: auto;
    background: #F1F7FC;
    box-shadow: 0px 4px 6px 0px rgba(175,214,251,0.2);
    border-radius: 4px;
    border: 2px solid #C3E2FF;
    padding: 15px;
    box-sizing: border-box;
    .report_title_adviceIcon{
      width: 137px;
      height: 34px;
    }
    .bot_advice_tit{
      box-sizing: border-box;
      padding-left: 14px;
      
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5E6779;
      line-height: 24px;
      position: relative;
      .bot_adv_tag{
        padding: 1px 10px 1px 5px;
        background: #FFE0E4;
        border-radius: 19px;
        border: 1px solid #FFB8C3;
        backdrop-filter: blur(8px);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #5E6779;

        display: inline-block;

        .tanhaoIcon{
          width: 14px;
          height: 14px;
          // margin-right: 3px;
          margin-top: -3px;
        }
      }
    }
    .bot_advice_tit::after{
      width: 4px;
      height: 4px;
      background: #80C0FD;
      border-radius: 2px;
      content: '';

      position: absolute;
      left: 0px;
      top: 11px;
    }
    .referAdvWrap{
      width: 766px;
      height: 172px;
      background: url(~@/assets/report_bg_advice_d.png) no-repeat no-repeat;
      background-size: contain;
      border-radius: 4px;
      backdrop-filter: blur(4px);
      padding: 0 15px;
      box-sizing: border-box;
      position: relative;
      z-index: 99;
      .referAdvList{
        display: flex;
        align-items: center;
        .rep_Icon{
          width: 34px;
          height: 34px;
        }
        .rep_tit{
          width: 700px;
          height: 53px;
          line-height: 53px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #5E6779;
          border-bottom: 1px solid #EFEFFC;
          margin-left: 5px;
        }
      }
      .referAdvList:nth-of-type(1){
        padding-top: 6px;
      }
      .referAdvList:nth-of-type(3) .rep_tit{
        border: none;
      }
    }
  }
}

</style>
